import { css } from 'styled-components';
export const breakText = () => css `
  overflow-wrap: break-word;
  word-wrap: break-word;
`;
//# sourceMappingURL=breakText.js.map